<template lang="">
    <div class='wrapper'>
        <router-link to="/newprofile/projects" class="icon">
            <a title="Home">
                <svg width="24" height="24" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24.1538 10.7967L14.0264 0.66928C13.5943 0.239182 13.0216 0 12.4106 0C11.7996 0 11.2268 0.237173 10.7947 0.66928L0.673307 10.7907C0.669287 10.7947 0.665258 10.7967 0.663248 10.8007C-0.223076 11.6911 -0.221084 13.1382 0.669259 14.0285C1.07524 14.4365 1.61191 14.6716 2.18471 14.6937C2.20682 14.6978 2.23088 14.6978 2.255 14.6978H2.65698V22.15C2.65698 23.6232 3.85682 24.8252 5.33202 24.8252H9.29336C9.69532 24.8252 10.0209 24.4996 10.0209 24.0977V18.2551C10.0209 17.5818 10.5696 17.0351 11.2408 17.0351H13.5762C14.2495 17.0351 14.7962 17.5818 14.7962 18.2551V24.0977C14.7962 24.4996 15.1217 24.8252 15.5237 24.8252H19.485C20.9602 24.8252 22.1601 23.6252 22.1601 22.15V14.6978H22.534C23.145 14.6978 23.7178 14.4586 24.1499 14.0285C25.0422 13.1362 25.0442 11.687 24.1538 10.7967Z" fill="url(#paint0_linear_62_54)"/>
                <defs>
                <linearGradient id="paint0_linear_62_54" x1="-0.00220738" y1="12.411" x2="24.8203" y2="12.411" gradientUnits="userSpaceOnUse">
                <stop stop-color="#00FFB7"/>
                <stop offset="1" stop-color="#008FC9"/>
                </linearGradient>
                </defs>
                </svg>
            </a>
        </router-link>
        <div @click="showSideBar" class="icon">
            <svg id="menuSVG" width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="4" fill="#141E34"/>
            <rect y="7" width="24" height="4" fill="#141E34"/>
            <rect y="14" width="24" height="4" fill="#141E34"/>
            </svg>
            <svg id="xMenuSVG" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="16.9706" width="24" height="4" transform="rotate(-45 0 16.9706)" fill="#141E34"/>
            <rect x="2.82843" width="24" height="4" transform="rotate(45 2.82843 0)" fill="#141E34"/>
            </svg>

        </div>
        <router-link to="/user-email" class="icon">
            <a title="Profile">
                <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.8873 13.2125C17.2213 13.2125 21.8017 16.595 23.5884 21.3201C23.914 22.1803 23.8055 23.0686 23.283 23.8263C22.7604 24.584 21.9665 25 21.046 25H2.72666C1.80617 25 1.01424 24.586 0.489677 23.8263C-0.0328722 23.0686 -0.141356 22.1823 0.184232 21.3201C1.97296 16.595 6.5533 13.2125 11.8873 13.2125ZM11.8873 0C8.82638 0 6.34637 2.48021 6.34637 5.54315C6.34637 8.60408 8.82839 11.0841 11.8873 11.0841C14.9482 11.0841 17.4285 8.60207 17.4285 5.54315C17.4285 2.48021 14.9482 0 11.8873 0Z" fill="url(#paint0_linear_62_55)"/>
                <defs>
                <linearGradient id="paint0_linear_62_55" x1="0.00192807" y1="12.4998" x2="23.7721" y2="12.4998" gradientUnits="userSpaceOnUse">
                <stop stop-color="#222A42"/>
                <stop offset="1" stop-color="#0C172B"/>
                </linearGradient>
                </defs>
                </svg>
            </a>
        </router-link>
    </div>
</template>
<script>
export default {
    data() {
    return {
    };
  },
  methods: {
      showSideBar() {
          const sideBar = document.getElementsByClassName('sidebar-wrapper')[0];
          const menuSVG = document.getElementById('menuSVG');
          const xMenuSVG = document.getElementById('xMenuSVG');
          if (sideBar.style.bottom == '0px') {
              sideBar.style.bottom = '-100vh'
              xMenuSVG.style.display = 'none';
              menuSVG.style.display = 'block';
          } else {
              sideBar.style.bottom = '0px'
              xMenuSVG.style.display = 'block';
              menuSVG.style.display = 'none';
          }
      }
    },
}
</script>
<style lang="scss" scoped>
    .wrapper {
        display: none;
        position: fixed;
        bottom: 0;
        width: 100%;
        background-color: #E9EAEC;
        align-items: center;
        justify-content: space-between;
        border-radius:15px 15px 0 0;
        box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;
        z-index: 999;

        .icon {
            width: 50px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            margin: 5px;
            transition: .3s all ease-in-out;
            cursor: pointer;
            &:hover {
                background-color: #3C66FF;
            }
        }

        #xMenuSVG {
            display: none;
        }
    }

    .icon:hover svg path  {
        fill: #FFF;
    }
    .icon:hover svg rect  {
        fill: #FFF;
    }

    @media screen and (max-width: 820px) {
        .wrapper {
        display: flex;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/global/sections/MobileBottomBar.vue